import shortid from 'shortid';

import { inch2px } from '../lib/unitConversions';

export class Material{
  static restore(instance) {
    const restored = new this(instance._material);
    const {
      id,
      key,
      index,
      positionY,
      typeIndex,
      name,
      warnings,
      errors
    } = instance;

    restored.id = id;
    restored.key = key;
    restored.index = index;
    restored.positionY = positionY;
    restored.typeIndex = typeIndex;
    restored.name = name;
    restored.warnings = warnings;
    restored.errors = errors;

    return restored;
  }

  constructor(material) {
    // These properties intended not to be changed once set
    this.key       = shortid.generate();
    this._material = material;

    // These properties intended to be calculated with other layers
    // in the stackup
    this.index     = 0;
    this.positionY = 0;
    this.typeIndex = 0;
    this.getLayers = () => undefined;

    // These properties inteded to be set by user;
    this.name      = undefined;

    // These properties will be set when user edit the material
    this.warnings = [];
  }

  get material() {
    return this._material;
  }

  get displayName() {
    return this.name || `${this.type}`;
  }

  get construction() {
    throw new Error("Not implemented");
  }

  get thickness_px() {
    return inch2px(this.thickness);
  }

  get pressedThickness() {
    return this.thickness;
  }

  get spaceNeeded() {
    throw new Error("Not implemented");
  }

  get viewProps() {
    throw new Error("Not implemented");
  }

  summary(unit) {
    return this.toString(unit);
  }
}

export default Material;


// WEBPACK FOOTER //
// ./src/models/Material.js